import React from 'react';
import OurServices from '../OurServices/OurServices';

const OurClasses = () => {
    return (
        <div className="backgroundAttach">
           <OurServices></OurServices>
        </div>
    );
};

export default OurClasses;